import { render, staticRenderFns } from "./CreateDepartments.vue?vue&type=template&id=b59354f2&"
import script from "./CreateDepartments.vue?vue&type=script&lang=js&"
export * from "./CreateDepartments.vue?vue&type=script&lang=js&"
import style0 from "./CreateDepartments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports